import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDelete, FullTable } from 'components';
import { Images, useModal } from 'utils';
import { createClientStyle } from 'fragments/client';
import { adminActions } from 'store';
import { EmploymentModal } from './modals';
import { pastEmploymentBody, pastEmploymentHead } from './constants';

const DELETE_ACTION_TYPE = 'DELETE_EMPLOYMENT';

export const PastStaffs = ({}) => {
    const classes = createClientStyle();
    const { employments, staffGeneral } = useSelector((state) => ({
        employments: state.admins.employments || [],
        staffGeneral: state.admins.adminInfoById,
    }));
    const sortedEmployments = [...employments].sort((a, b) => {
        const dateA = a?.endDate ? new Date(a.endDate).getTime() : 0;
        const dateB = b?.endDate ? new Date(b.endDate).getTime() : 0;
        return dateB - dateA;
    });

    const { open } = useModal();
    const dispatch = useDispatch();

    const handleAction = (item, name) => {
        if (name === 'edit') {
            open(<EmploymentModal edit={item} />);
        }
        if (name === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this past employment? This action cannot be undone."
                    info="Delete Past Employment"
                    handleDel={() => dispatch(adminActions.deleteEmployment(item?.id, staffGeneral?.id))}
                    actionType={DELETE_ACTION_TYPE}
                    body={
                        <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                            <img style={{ marginTop: '3px' }} src={Images.briefcase} alt="icon" />
                            <p style={{ fontWeight: 600 }}>{item?.title?.name}</p>
                        </div>
                    }
                />
            );
        }
    };

    return (
        <div style={{ width: '1200px', maxWidth: '100%' }}>
            <div className={classes.pastEmploymentHeader} style={{ padding: 0 }}>
                <img src={Images.pastEmployment} alt="pastEmployment" />
                <p>Past Employments</p>
            </div>
            <div className="modal-body-style" style={{ padding: '24px 0 0 0' }}>
                <FullTable
                    head={pastEmploymentHead}
                    body={pastEmploymentBody}
                    list={sortedEmployments}
                    noText={'Past Employments'}
                    height={'medium'}
                    handleClickButton={handleAction}
                    margin={'0'}
                    minWidth={1100}
                />
            </div>
        </div>
    );
};
